<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">

    <!-- Header: título + botões de ação -->
    <div class="row mb-4">
      <div class="col-12 col-md-6">
        <h1 class="title-default">FCI - Ficha de Conteúdo de Importação</h1>
        <p class="welcome-message">Obrigação acessória de ICMS para produtos com insumos importados</p>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-flat-button class="btn-primary" type="button" (click)="incluir()">
          <span class="material-symbols-outlined">add</span>
          Incluir FCI
        </button>
      </div>
    </div>

    <!-- Filtro de período -->
    <div class="row search-area align-items-center">
      <div class="col-12 d-flex align-items-center gap-2 flex-wrap">
        <button mat-icon-button (click)="navegarMes(-1)" aria-label="Mês anterior" matTooltip="Mês anterior">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <span class="mes-seletor-wrapper">
          <button mat-stroked-button class="btn-filter" type="button" (click)="abrirSeletor()">
            <mat-icon>calendar_month</mat-icon>
            {{ mesAnoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>

          @if (seletorAberto) {
          <div class="mes-seletor-popup">
            <div class="mes-seletor-ano">
              <button mat-icon-button (click)="navegarAnoSeletor(-1)"><mat-icon>chevron_left</mat-icon></button>
              <span class="ano-label">{{ anoSeletor }}</span>
              <button mat-icon-button (click)="navegarAnoSeletor(1)"><mat-icon>chevron_right</mat-icon></button>
            </div>
            <div class="mes-seletor-grid">
              @for (nome of nomesMeses; track nome; let i = $index) {
              <button type="button" class="mes-seletor-item" [class.ativo]="(i + 1) === mes && anoSeletor === ano"
                (click)="selecionarMes(i + 1)">
                {{ nome.slice(0, 3) }}
              </button>
              }
            </div>
          </div>
          }
        </span>

        <button mat-icon-button (click)="navegarMes(1)" aria-label="Próximo mês" matTooltip="Próximo mês">
          <mat-icon>chevron_right</mat-icon>
        </button>

        <button mat-stroked-button class="btn-filter" type="button" (click)="limparFiltros()">
          <mat-icon>cleaning_services</mat-icon>
          Limpar filtros
        </button>
      </div>
    </div>

    <!-- Loading -->
    @if (isLoading && itens.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (!isLoading && itens.length === 0) {
    <app-empty-list title="Nenhuma FCI encontrada" subTitle="Tente alterar o período ou inclua uma nova ficha">
    </app-empty-list>
    } @else {
    <!-- Desktop table -->
    <div class="desktop-view">
      <table mat-table [dataSource]="itens" class="w-100">

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox
              (change)="$event ? (selecionados.size === itens.length ? selecionados.clear() : itens.forEach(i => selecionados.add(i.idFci))) : null"
              [checked]="selecionados.size > 0 && selecionados.size === itens.length"
              [indeterminate]="selecionados.size > 0 && selecionados.size < itens.length">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="w-checkbox">
            <mat-checkbox (click)="$event.stopPropagation()"
              (change)="$event ? (selecionados.has(row.idFci) ? selecionados.delete(row.idFci) : selecionados.add(row.idFci)) : null"
              [checked]="selecionados.has(row.idFci)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="numero">
          <th mat-header-cell *matHeaderCellDef>Número</th>
          <td mat-cell *matCellDef="let row">
            <button class="link-numero" (click)="editar(row)">#{{ row.idFci }}</button>
          </td>
        </ng-container>

        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef>Data</th>
          <td mat-cell *matCellDef="let row">{{ row.datetimeInclusao | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="protocolo">
          <th mat-header-cell *matHeaderCellDef>Protocolo</th>
          <td mat-cell *matCellDef="let row">
            <span [class]="statusProtocoloClass(row)">
              {{ row.protocoloRecepcao ?? 'não informado' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="mercadorias">
          <th mat-header-cell *matHeaderCellDef>Mercadorias</th>
          <td mat-cell *matCellDef="let row">{{ row.totalMercadorias }} {{ row.totalMercadorias === 1 ? 'item' : 'itens'
            }}</td>
        </ng-container>

        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef class="w-actions text-center">Ações</th>
          <td mat-cell *matCellDef="let row" class="w-actions">
            <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #menuRow="matMenu">
              <button mat-menu-item (click)="editar(row)">
                <span class="material-symbols-outlined">edit</span>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="exportar(row)">
                <span class="material-symbols-outlined">file_download</span>
                <span>Exportar arquivo</span>
              </button>
              <button mat-menu-item (click)="excluir(row)">
                <span class="material-symbols-outlined">delete</span>
                <span>Excluir</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Mobile cards -->
    <div class="mobile-view">
      @for (row of itens; track row.idFci) {
      <div class="card-mobile mb-3">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <button class="link-numero" (click)="editar(row)">#{{ row.idFci }}</button>
            <span class="text-secondary" style="font-size: 12px">{{ row.datetimeInclusao | date:'dd/MM/yyyy' }}</span>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="menuMobile" (click)="$event.stopPropagation()">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item (click)="editar(row)">
              <span class="material-symbols-outlined">edit</span>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="exportar(row)">
              <span class="material-symbols-outlined">file_download</span>
              <span>Exportar arquivo</span>
            </button>
            <button mat-menu-item (click)="excluir(row)">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir</span>
            </button>
          </mat-menu>
        </div>
        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-1">
              <small class="d-block text-secondary">Protocolo</small>
              <span [class]="statusProtocoloClass(row)">{{ row.protocoloRecepcao ?? 'não informado' }}</span>
            </div>
            <div class="col-6 mb-1">
              <small class="d-block text-secondary">Mercadorias</small>
              <span>{{ row.totalMercadorias }} {{ row.totalMercadorias === 1 ? 'item' : 'itens' }}</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Ver Mais -->
    <div class="text-center mt-3">
      <button mat-button (click)="proximaPagina()" [disabled]="ultimaPagina || isLoading">
        @if (isLoading) {
        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver mais
        }
      </button>
    </div>
    }
  </div>
</div>